import { Stack } from '@mantine/core'
import type { PropertyWithRelations, ScheduledVisit } from '@markku/types'
import { DocumentsCard } from './DocumentsCard'
import { CompletedTasksList } from './CompletedTasksList'
import { DefectsNotesCard } from './DefectsNotesCard'
import { FloorPlanCard } from './FloorPlanCard'
import { PropertySurveyCard } from './PropertySurveyCard'
import { VisitNotesCard } from './VisitNotesCard'
import { VisitPaymentCard } from './VisitPaymentCard'
import { VisitSummaryCard } from './VisitSummaryCard'

interface PastVisitProps {
  visit: ScheduledVisit
  property?: PropertyWithRelations
  /** Open the feedback modal on mount — set by the one-click email link. */
  autoOpenFeedback?: boolean
  /** Rating pre-filled in the feedback modal when arriving from email. */
  initialFeedbackRating?: number
}

export function PastVisit({
  visit,
  property,
  autoOpenFeedback,
  initialFeedbackRating,
}: PastVisitProps) {
  const isSurvey = visit.eventType === 'survey'

  return (
    <Stack gap="lg">
      <VisitSummaryCard
        visit={visit}
        autoOpenFeedback={autoOpenFeedback}
        initialFeedbackRating={initialFeedbackRating}
      />
      {visit.status === 'completed' && <VisitPaymentCard visit={visit} />}
      <VisitNotesCard visit={visit} />
      <DefectsNotesCard visit={visit} />
      <FloorPlanCard visit={visit} />
      {isSurvey && <PropertySurveyCard visit={visit} />}
      <DocumentsCard visit={visit} property={property} />
      <CompletedTasksList visit={visit} />
    </Stack>
  )
}
